import { render, staticRenderFns } from "./axsr-register-success.vue?vue&type=template&id=4264e7ae&"
import script from "./axsr-register-success.vue?vue&type=script&lang=js&"
export * from "./axsr-register-success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports